module.exports = "<footer class=\"app-footer\">\r\n    <!-- <span class=\"ml-auto\">&copy; 2018 Oros</span> -->\r\n    <span class=\"ml-auto copyright\">Copyright &copy; 2018 Oros. All Rights Reserved.</span>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/app-footer/app-footer.component.html
// module id = ./src/app/shared/components/app-footer/app-footer.component.html
// module chunks = main